module.exports = __webpack_public_path__ + "./Phoebe2_c98c00b2bacebd940f069dd01e190098.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2022/Phoebe2.png
// module id = 577
// module chunks = 0